import {
  CLEAR_REQUEST,
  SET_ADMIN,
  SET_BUSINESS_CREATION,
  SET_DOMICILIATION,
  SET_GRH,
  SET_JURIDIQUE,
  SET_MANAGEMENT,
  SET_ODOO,
  SET_SALES,
  SET_USER_BUSINESS_CREATION_REQUESTS,
  SET_USER_MANAGEMENT_REQUESTS,
  SET_USER_ODOO_REQUESTS,
  SET_USER_SALES_REQUESTS,
  UPDATE_ADMIN,
  UPDATE_BUSINESS_CREATION,
  UPDATE_DOMICILIATION,
  UPDATE_GRH,
  UPDATE_JURIDIQUE,
  UPDATE_MANAGEMENT,
  UPDATE_ODOO,
  UPDATE_SALES,
} from "../actions/RequestActions";

const initialState = {
  businessRequest: null,
  domiciliationRequest: null,
  managementRequest: null,
  juridiqueRequest: null,
  grhRequest: null,
  salesRequest: null,
  adminRequest: null,
  userManagementRequest: null,
  userSalesRequest: null,
};

const RequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BUSINESS_CREATION:
      return {
        ...state,
        businessCreationRequest: action.payload,
      };
    case SET_USER_BUSINESS_CREATION_REQUESTS:
      return {
        ...state,
        userBusinessCreationRequests: action.payload,
      };
    case UPDATE_BUSINESS_CREATION:
      return {
        ...state,
        businessRequest: { ...state.businessRequest, ...action.payload },
      };

    case SET_DOMICILIATION:
      return {
        ...state,
        domiciliationRequest: action.payload,
      };
    case UPDATE_DOMICILIATION:
      return {
        ...state,
        domiciliationRequest: {
          ...state.domiciliationRequest,
          ...action.payload,
        },
      };

    case SET_MANAGEMENT:
      return {
        ...state,
        managementRequest: action.payload,
      };
    case SET_USER_MANAGEMENT_REQUESTS:
      return {
        ...state,
        userManagementRequest: action.payload,
      };
    case UPDATE_MANAGEMENT:
      return {
        ...state,
        managementRequest: {
          ...state.managementRequest,
          ...action.payload,
        },
      };

    case SET_ODOO:
      return {
        ...state,
        odooRequest: action.payload,
      };
    case SET_USER_ODOO_REQUESTS:
      return {
        ...state,
        userOdooRequest: action.payload,
      };
    case UPDATE_ODOO:
      return {
        ...state,
        odooRequest: {
          ...state.odooRequest,
          ...action.payload,
        },
      };

    case SET_JURIDIQUE:
      return {
        ...state,
        juridiqueRequest: action.payload,
      };
    case UPDATE_JURIDIQUE:
      return {
        ...state,
        juridiqueRequest: {
          ...state.juridiqueRequest,
          ...action.payload,
        },
      };

    case SET_ADMIN:
      return {
        ...state,
        adminRequest: action.payload,
      };
    case UPDATE_ADMIN:
      return {
        ...state,
        adminRequest: {
          ...state.adminRequest,
          ...action.payload,
        },
      };

    case SET_SALES:
      return {
        ...state,
        salesRequest: action.payload,
      };
    case SET_USER_SALES_REQUESTS:
      return {
        ...state,
        userSalesRequest: action.payload,
      };
    case UPDATE_SALES:
      return {
        ...state,
        salesRequest: {
          ...state.salesRequest,
          ...action.payload,
        },
      };

    case SET_GRH:
      return {
        ...state,
        grhRequest: action.payload,
      };
    case UPDATE_GRH:
      return {
        ...state,
        grhRequest: {
          ...state.grhRequest,
          ...action.payload,
        },
      };

    case CLEAR_REQUEST:
      return initialState;
    default:
      return state;
  }
};

export default RequestReducer;
